import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import Item from '../../components/itens/item'


function ObrasScreen() {
    return (
        <Fragment>
            <Head titulo="Obras Públicas" />
            <Header />
            <Container>
                <Row xs={1} lg={2}>
                    <Col>
                        <Item
                            titulo={"Todas Obras"}
                            descricao={"Veja aqui a listagem de todas Obras Públicas realizadas em todas situações no município"}
                            awesome={"faPersonDigging"}
                            link={"obras/todas"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Obras Paralizadas"}
                            descricao={"Veja aqui todas Obras Públicas paralizadas no município, tal como motivo da paralização"}
                            awesome={"faHand"}
                            link={"obras/paralizadas"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ObrasScreen;